export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/PerformanceFeature.045a3464.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};